export const sleep = (ms = 1000) => new Promise(resolve => setTimeout(resolve, ms))

export const disableFormSubmitByEnterKey = (event) => {
  event.persist();
  if (event.key === "Enter") {
    event.preventDefault(); // stop form submit!
  }
};
